<template>
  <el-card>
    <div>
      <el-button icon="el-icon-arrow-left" @click="back()">取消</el-button>
      <el-form ref="realForm" :model="realForm" :rules="rules">
        <!-- <el-form-item label="标题" label-width="100px" prop="name">
          <el-input v-model="realForm.name" style="width: 400px;border: none"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="简介" label-width="100px" prop="intro">
          <el-input maxlength="100" type="textarea" rows="4" v-model="realForm.intro"></el-input>
        </el-form-item> -->
        <el-form-item label="调显码" label-width="100px" prop="code">
          <el-input v-model="realForm.code" style="width: 400px;" oninput="value=value.replace(/[\u4e00-\u9fa5]/ig,'')"></el-input>
        </el-form-item>
        <el-form-item label="形式" label-width="100px" prop="type">
          <el-radio-group v-model="realForm.type" @change="selectType">
            <el-radio-button label="1">单图</el-radio-button>
            <el-radio-button label="0">轮播</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" label-width="100px" prop="content">
          <el-input v-model="realForm.content" style="width: 400px;"></el-input>
        </el-form-item>
        <el-form-item label-width="100px">
          <span style="font-size:8px">备注:请填写尺寸等信息</span>
        </el-form-item>
        <el-form-item>
          <el-divider></el-divider>
          <div class="newvideo">
            <ul class="clearfloat">
              <li v-for="item in typeList" :key="item.id">
                <el-image :src="item.url" fit="cover"></el-image>
                <div>
                  <span style="margin-left: 20px">{{item.sortId}}</span>
                  <el-divider direction="vertical"></el-divider>
                  <span>{{item.clickUrl == '' ? '无链接':'有链接'}}</span>
                  <el-divider direction="vertical"></el-divider>
                  <span>{{item.isClick == 'Y' ? '弹出':'不弹出'}}</span>
                  <el-button
                    style="margin-left: 20px"
                    type="primary"
                    @click="edit(item.id)"
                    size="mini"
                    round
                  >编辑</el-button>
                  <el-button
                    style="margin-left: 20px"
                    type="primary"
                    @click="deletePic(item.id)"
                    size="mini"
                    round
                  >删除</el-button>
                </div>
              </li>
            </ul>
          </div>
          <el-button type="success" :disabled="disabled" @click="addImg('realForm')">添加广告图</el-button>
          <el-divider></el-divider>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('realForm')">保存</el-button>
          <el-button @click="resetForm('realForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>

<script>
import qs from "qs";
export default {
  data() {
    var introPass = (rule,value,callback)=>{
      if(value == 100){
        callback(new Error('字符不能超过100'))
      }else{
        callback();
      }

    }
    return {
      disabled: false,
      typeList: [],
      realForm: {
        // name: "",
        code: "",
        type: "1",
        content: "",
        intro:''
      },
      isRadio: "",
      rules: {
        //表单规则
        // name: [
        //   {
        //     required: true,
        //     message: "此项为必填项",
        //     trigger: "blur"
        //   }
        // ],
        code: [{ required: true, message: "此项为必填项", trigger: "blur" }],
        type: [{ required: true, message: "请选择形式", trigger: "change" }],
        intro:[{ required: true, message: "简介不能为空", trigger: "blur" },
            {validator:introPass,trigger:'change'}
        ]
      }
    };
  },
  methods: {
    //获取宣传位详情
    getAdvertiseInfo: async function() {
      var id = this.$route.query.id;
      var res = await this.$http.get(`/v1/advertise/advertiselist?id=${id}`);
      var { code, message, data } = res.data;
      if (code == 0) {
        this.realForm = data;
        this.isRadio = data.type == "1" ? "单图" : "轮播";
      }
    },
    //获取宣传位中图片列表
    getAdvertisePicList: async function() {
      var advertiseCode = this.$route.query.code;
      var res = await this.$http.get(
        `/v1/advertise/getByCode?code=${advertiseCode}`
      );
      var { code, message, data } = res.data;
      if (code == 0) {
        this.typeList = data;
        console.log("type", this.typeList);
      }
    },
    //选择类别
    selectType: async function() {
      // if (this.isRadio == "单图") {
      //   if (this.typeList.length > 1) {
      //     this.disabled = false;
      //   }
      //   this.disabled = true;
      // } else {
      //   this.disabled = false;
      // }
      await this.getAdvertisePicList();
      if (this.realForm.type == "1") {
        console.log(this.typeList.length);
        if (this.typeList.length == 0) {
          this.disabled = false;
        } else {
          this.disabled = true;
        }
      } else {
        this.disabled = false;
      }
      // this.realForm.type = this.isRadio == "单图" ? "1" : "0";
    },
    submitForm: function(formName) {
      this.$refs[formName].validate(async valid => {

        if(this.typeList.length == 0){
          this.$message.error("请添加广告图");
        }else{
          if (valid) {
            var res = await this.$http.post(
              `/v1/advertise/advertiseGroup`,
              qs.stringify(this.realForm)
            );
            var { code, message, data } = res.data;
            if (code == 0) {
              this.$router.push({
                path: "/AdvertiseGroup",
                query: {
                  id: data.id,
                  code: data.code
                }
              });
              this.$message.success("添加/编辑成功");
              console.log("第一步：", data);
            } else {
              this.$message.error(message);
            }
          }
        }
      });
    },
    addImg: function(realForm) {
      console.log(this.realForm)
      this.$refs[realForm].validate(async valid => {
        if (valid) {
          var res = await this.$http.post(
            `/v1/advertise/advertiseGroup`,
            qs.stringify(this.realForm)
          );
          var { code, message, data } = res.data;
          if (code == 0) {
            // var advertiseId = this.$route.query.id;
            // var advertiseCode = this.$route.query.code;
            // this.$router.push({
            //   path: `/AdvertiseAddImg`,
            //   query: { id: advertiseId, code: advertiseCode }
            // });
            this.$router.push({
              path: "/AdvertiseAddImg",
              query: {
                id: data.id,
                code: data.code
              }
            });
          } else {
            this.$message.error(message);
          }
        } else {
          this.$message.error("请填写必填项");
        }
      });
    },
    edit: async function(id) {
      var advertiseId = this.$route.query.id;
      var advertiseCode = this.$route.query.code;
      this.$router.push({
        path: `/AdvertiseAddImg`,
        query: {
          imgId: id,
          id: advertiseId,
          code: advertiseCode
        }
      });
    },
    deletePic: function(id) {
      this.$confirm("确定删除吗？", "提示", {
        confirmTextButton: "确定",
        cancelTextButton: "取消",
        type: "warning"
      })
        .then(async () => {
          var res = await this.$http.post(`/v1/advertise/deletePic?id=${id}`);
          var { code, data, message } = res.data;
          if (code == 0) {
            this.$message.success("删除成功！");
            this.getAdvertisePicList();
            this.selectType();
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {});
    },
    back() {
      this.$router.push(`/AdvertiseGroup`);
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  mounted() {
    this.getAdvertiseInfo();
    this.getAdvertisePicList();
    this.selectType();
  }
};
</script>

<style lang="scss" scoped>

.el-image {
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    // display: block;
    vertical-align: middle;
  }
}

  .v_image {
    position: static;
    z-index: 1;
  }
// ----------------------
  // 宣传位图片列表
  .newvideo li {
    width: 32%;
    float: left;
    margin-right: 2%;
    margin-bottom: 30px;
    &:nth-child(3n) {
      margin-right: 0;
    }
    .el-image {
      height: 200px;
    }
    div span {
      font-size: 14px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/backgroundMg/advertise-mg/AdvertiseDetail.vue